<script setup>
import { RouterView } from 'vue-router';
import UpdateBanner from '@/components/UpdateBanner.vue';
</script>

<template>
  <RouterView />
  <UpdateBanner />
</template>
<script>

// import userApi from '@/api/user';

export default {
  data() {
    return {
      debounceTimeout: null,
    };
  },
  async mounted() {
    const token = localStorage.getItem('token');
    if (!token) {
      // this.$router.push('/auth/login');
    }
  },
};

</script>
